import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { authActions } from "../../store/actions/auth.actions";
import { IDRaksStore } from "../../store/store";
import { Redirect } from "react-router-dom";
import useWybranaOrganizacja from "../../hooks/useWybranaOrganizacja";

interface LoginPageProps {
  isLogged: boolean;
  onConfirmEmail: Function;
  match: any;
}

const ConfirmEmailPage = (props: LoginPageProps) => {
  const confEmail = props.match.params.email;
  const token = props.match.params.token;
  const [res, setRes] = useState("");
  const { idWybranej: id } = useWybranaOrganizacja();

  useEffect(() => {
    props.onConfirmEmail(confEmail, token).then(() => {
      if (props.isLogged) setRes("logged");
      else setRes("notlogged");
    });
    // eslint-disable-next-line
  }, []);

  return res === "logged" ? (
    <Redirect to={`/${id}/organizacje`} />
  ) : res === "notlogged" ? (
    <Redirect to="/login" />
  ) : (
    <div></div>
  );
};

function mapStateToProps(store: IDRaksStore) {
  return {
    isLogged: store.auth.isLogged,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onConfirmEmail: (email: string, token: string) =>
      dispatch(authActions.confirmEmail(email, token)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmailPage);
